var en_us = {
    values: {
        "api key http not be empty": "api web key must not be empty",
        "api key web": "API WEB Key",
        "api key web services": "API WEB Services Key",
    }
};

module.exports = en_us;
